/*
 * @FilePath: \badayuan-frontendb\src\api\services\student.js
 * @Author: WSY
 * @Date: 2024-04-17 09:37:35
 * @LastEditTime: 2024-04-17 09:49:46
 * @Description: 
 */
/**
 * @Author: HJK
 * @Date: 2023-04-27 15:35:49
 * @LastEditTime: 2023-11-06 17:29:52
 * @LastEditors: HJK
 * @Description:
 * @FilePath: \badayuan-frontend-gitee\src\api\services\student.js
 */
/**
 * 学生和班级相关
 */
import APIDOC from '../model/serverApi';
import { get, post } from '../model/request';

//学生相关=>
//课程分类==>
export function addCourseCategory(params = {}) { return post(APIDOC.STUDENT.C_courseCategory, params) }//增
export function deleteCourseCategory(categoryId) { return get(APIDOC.STUDENT.D_courseCategory, { categoryId }) }//删
export function getCourseCategoryList(params) { return post(APIDOC.STUDENT.R_courseCategory, params) }//查
export function updateCourseCategory(params) { return post(APIDOC.STUDENT.U_courseCategory, params) }//改
//【学科专业】
export function addEduMajor(params = {}) { return post(APIDOC.STUDENT.C_eduMajor, params) }//增
export function deleteEduMajor(majorId) { return get(APIDOC.STUDENT.D_eduMajor, { majorId }) }//删
export function getEduMajorList(params) { return post(APIDOC.STUDENT.R_eduMajor, params) }//查
export function updateEduMajor(params) { return post(APIDOC.STUDENT.U_eduMajor, params) }//改
//【教师管理】
export function au_Teacher(params = {}) { return post(APIDOC.STUDENT.CU_teacher, params) }//增改
export function getTeacherList(params) { return post(APIDOC.STUDENT.R_teacher, params) }//查
export function getTeacherOne(teacherId) { return get(APIDOC.STUDENT.R_teacher_one, { teacherId }) }//删
export function setTeacherRecommend(teacherId) { return get(APIDOC.STUDENT.S_teacher, { teacherId }) }//首页推荐或者不推荐
//【课程管理】
export function addCourse(params = {}) { return post(APIDOC.STUDENT.C_course, params) }//增
export function updateCourseBasic(params = {}) { return post(APIDOC.STUDENT.U_course, params) }//改，课程基础信息
export function updateCourseChapter(params = {}) { return post(APIDOC.STUDENT.U_course_chapter, params) }//改，课程的章节信息
export function getCourseList(params) { return post(APIDOC.STUDENT.R_course, params) }//查，课程列表
export function getCourseOne(courseId) { return get(APIDOC.STUDENT.R_course_one, { courseId }) }//查，一条课程详情
export function getCourseChapter(courseId) { return get(APIDOC.STUDENT.R_course_chapter, { courseId }) }//查，一条课程章节信息
export function course_recommend(courseId) { return get(APIDOC.STUDENT.Course_recommend, { courseId }) }//首页推荐
export function course_unRecommend(courseId) { return get(APIDOC.STUDENT.Course_unRecommend, { courseId }) }//取消首页推荐
export function getComputedDuration(courseId) { return get(APIDOC.STUDENT.C_calDuration, { courseId }) }//计算时长
//【班级管理】
export function addClass(params = {}) { return post(APIDOC.STUDENT.C_class, params) }//增
export function addClassStudent(params = {}) { return post(APIDOC.STUDENT.C_class_student_add, params) }//新增班级学生
export function deleteClassStudent(params = {}) { return post(APIDOC.STUDENT.D_class_student_delete, params) }//删除班级学生
export function updateClass(params) { return post(APIDOC.STUDENT.U_class, params) }//改
export function deleteClass(classId) { return get(APIDOC.STUDENT.D_class, { classId }) }//删
export function getClassList(params) { return post(APIDOC.STUDENT.R_class, params) }//查
export function getClassOne(classId) { return get(APIDOC.STUDENT.R_class_one, { classId }) }//查一个
//【学生管理】
export function getStudentList(params) { return post(APIDOC.STUDENT.R_student, params) }//查，学生管理列表
export function getStudentFormat(params) { return post(APIDOC.STUDENT.R_student_format, params) }//查，用于班级管理>班级学生设置的左侧表回显
export function auStudent(params = {}) { return post(APIDOC.STUDENT.CU_student, params) }//增改
export function importByExcelStudent(params = {}) { return post(APIDOC.STUDENT.I_student, params) }//批量导入学生
export function deleteStudent(studentId, bid) { return get(APIDOC.STUDENT.D_student, { studentId, bid }) }//删
export function getStudentOne(studentId, bid) { return get(APIDOC.STUDENT.R_student_one, { studentId, bid }) }//查一个
export function resetStudentPass(studentId) { return get(APIDOC.STUDENT.P_student, { studentId }) }//重置密码
export function faceImgCheckStudent(params = {}) { return post(APIDOC.STUDENT.F_student, params) }//人脸信息审核
export function cardCheckStudent(params = {}) { return post(APIDOC.STUDENT.CC_student, params) }//实名身份信息审核
//【批次学生管理】
export function getClassStudentList(params) { return post(APIDOC.STUDENT.R_class_student, params) }//查
export function getClassTree(params) { return post(APIDOC.STUDENT.R_class_tree, params) }//获取班级的树
export function greduateClass(params) { return post(APIDOC.STUDENT.G_class, params) }//结业
export function unGreduateClass(params) { return post(APIDOC.STUDENT.G_class_un, params) }//撤销结业
export function getClassStudentInfo(params) { return post(APIDOC.STUDENT.P_student_info, params) }//班级学生课程学习情况
export function download2ClassStu(paramStr) { post(APIDOC.STUDENT.D_classStuDownload + paramStr) }//导出
export function handleClassStuRefersh(params) { return get(APIDOC.STUDENT.R_class_student_brush, params) }//刷课
// 【友情链接管理】
export function getFriendLinkList(params) { return post(APIDOC.STUDENT.R_friendLink, params) }//查
export function au_friendLink(params = {}) { return post(APIDOC.STUDENT.CU_friendLink, params) }//增改
export function deleteFriendLink(linkId) { return get(APIDOC.STUDENT.D_friendLink, { linkId }) }//删
export function getFriendLinkOne(linkId) { return get(APIDOC.STUDENT.R_friendLink_one, { linkId }) }//查一个
// 【系统导航管理】
export function getSystem_navList(params) { return post(APIDOC.STUDENT.R_system_navList, params) }//查
export function au_system_navList(params = {}) { return post(APIDOC.STUDENT.CU_system_navList, params) }//增改
export function enableSystem_navList(navigationId) { return get(APIDOC.STUDENT.E_system_navList, { navigationId }) }//启用系统导航
export function disableSystem_navList(navigationId) { return get(APIDOC.STUDENT.D_system_navList, { navigationId }) }//禁用系统导航
export function getSystem_navListOne(navigationId) { return get(APIDOC.STUDENT.R_system_navList_one, { navigationId }) }//查一个
// 【文章发布】
export function getNews_categoryList() { return get(APIDOC.STUDENT.R_news_categoryList) }//查文章分类列表
export function getNews_List(params) { return post(APIDOC.STUDENT.R_news_List, params) }//查文章
export function au_news_List(params = {}) { return post(APIDOC.STUDENT.CU_news_List, params) }//增改
export function deleteNews_List(newsId) { return get(APIDOC.STUDENT.D_news_list, { newsId }) }//删
export function getnews_ListOne(newsId) { return get(APIDOC.STUDENT.R_news_List_one, { newsId }) }//查一个
// 【系统消息】
export function getSystem_message(params) { return post(APIDOC.STUDENT.R_system_message, params) }//系统消息列表
export function addSystem_message(params = {}) { return post(APIDOC.STUDENT.C_system_message, params) }//发布系统消息
export function deleteSystem_message(messageId) { return get(APIDOC.STUDENT.D_system_message, { messageId }) }//消息撤回
//【学生抓拍查看】
export function getStudentCaptureList(params) { return post(APIDOC.STUDENT.R_student_capture, params) }//系统消息列表
// 学员批次管理
export function getStudentBatchList(params) { return post(APIDOC.STUDENT.R_student_batch, params) }//查
export function getStudentBatchTimeList(params) { return post(APIDOC.STUDENT.R_student_batch_time, params) }//查




// WEBPACK FOOTER //
// ./src/api/services/student.js